import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--client-list-edit-modal',
    ];

    openEditModal(event) {
        event.preventDefault();
        this.profileClientListEditModalOutlet.openModal();
    }
}
